export default __webpack_public_path__ + "static/bravos-ec2e74b1eb31efa39c0954c6a28e9baf.png";